export default "__VITE_ASSET__B_ZAT83f__"